/*(function(doc, win) {
    var docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function() {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            docEl.style.fontSize = 20 * (clientWidth / 320) + 'px';
        };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);*/

! function (j, i) {
  function k() {
    var c, d = p.getBoundingClientRect().width;
    d > 750 && (d = 750), c = d / 10, p.style.fontSize = c + "px"
  }
  var o, l, p = j.documentElement,
    n = j.querySelector('meta[name="viewport"]'),
    m = "width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=no";
  n ? n.setAttribute("content", m) : (n = j.createElement("meta"), n.setAttribute("name", "viewport"), n.setAttribute(
    "content", m), p.firstElementChild ? p.firstElementChild.appendChild(n) : (l =
    j.createElement("div"), l.appendChild(n), j.write(l.innerHTML))), k(), i.addEventListener("resize", function () {
    clearTimeout(o), o = setTimeout(k, 300)
  }, !1), i.addEventListener("pageshow", function (b) {
    b.persisted && (clearTimeout(o), o = setTimeout(k, 300))
  }, !1), "complete" === j.readyState ? j.body.style.fontSize = "16px" : j.addEventListener("DOMContentLoaded", function () {
    j.body.style.fontSize = "16px"
  }, !1)
}(document, window);
